import React from 'react';
import RestInputItem from '../../../../components/RestInput/RestInputItem';

const DeliversForm = props => (
  <div {...props}>
    <RestInputItem source="name" header="delivers.name" />
  </div>
);

DeliversForm.propTypes = {};

export default DeliversForm;
